import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { EnergyflatComponent } from './energyflat.component';
import { EnergyflatDetailComponent } from './energyflat-detail.component';
import { EnergyflatPopupComponent } from './energyflat-dialog.component';
import { EnergyflatDeletePopupComponent } from './energyflat-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class EnergyflatResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const energyflatRoute: Routes = [
  {
    path: 'energyflat',
    component: EnergyflatComponent,
    resolve: {
      'pagingParams': EnergyflatResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.energyflat.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'energyflat/:id',
    component: EnergyflatDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.energyflat.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const energyflatPopupRoute: Routes = [
  {
    path: 'energyflat-new',
    component: EnergyflatPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.energyflat.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'energyflat/:id/edit',
    component: EnergyflatPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.energyflat.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'energyflat/:id/delete',
    component: EnergyflatDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.energyflat.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/energyflat/energyflat.route.ts